import { Pipe, PipeTransform, ChangeDetectorRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { getOwnerRole } from '../states-management/selector/owner.selector';
import { getCountry } from '../states-management/selector/countries.selector';

@Pipe({
  name: 'translate',
  pure: false
})
export class CustomTranslatePipe extends TranslatePipe implements PipeTransform {

  ownerRole: string = 'farmer';
  country_id: number = null;
  constructor(public translateService: TranslateService, changeDetectorRef: ChangeDetectorRef, public store: Store) {
    super(translateService, changeDetectorRef);
    this.store.select(getOwnerRole).subscribe((role) => {
      this.ownerRole = role;
    });

    this.store.select(getCountry).subscribe((country) => {
      if (country) {
        this.country_id = country?.id
      }
    });
  }


  private replaceWordWithCase(text: string, sourceWord: string, targetWord: string): string {
    if (!sourceWord || !targetWord) return text;

    let result = text;

    // Handle different case variations
    const sourceLower = sourceWord.toLowerCase();
    const sourceUpper = sourceWord.toUpperCase();
    const sourceCapitalized = sourceWord.charAt(0).toUpperCase() + sourceWord.slice(1).toLowerCase();

    const targetLower = targetWord.toLowerCase();
    const targetUpper = targetWord.toUpperCase();
    const targetCapitalized = targetWord.charAt(0).toUpperCase() + targetWord.slice(1).toLowerCase();

    // Replace different case variations
    result = result.replace(new RegExp(`\\b${sourceLower}\\b`, 'g'), targetLower);
    result = result.replace(new RegExp(`\\b${sourceUpper}\\b`, 'g'), targetUpper);
    result = result.replace(new RegExp(`\\b${sourceCapitalized}\\b`, 'g'), targetCapitalized);

    return result;
  }
  transform(query: string, ...args: any[]): any {
    if (!query) return ''; // handle null/empty gracefully

    const result = super.transform(query, ...args);



    var modifiedResult = result;
    if (modifiedResult && typeof modifiedResult === 'string') {

      if ([18, 19].includes(this.country_id)) {
        const hectaresTerms = this.translateService.instant('label.hectars');
        const hectareTerms = this.translateService.instant('label.hectar');
        const acreTerm = this.translateService.instant('label.acre');
        const hectareAbbrev = this.translateService.instant('label.ha');
        const hect = this.translateService.instant('ha');
        const acreAbbrev = this.translateService.instant('label.acre_abbrev');
        const tree_ha = this.translateService.instant('tree_ha');
        const tree_acre = this.translateService.instant('tree_acre');

        // Replace full hectare terms
        if (query == 'ha') {
          // modifiedResult = this.replaceWordWithCase(modifiedResult, hect, acreTerm);
          modifiedResult = modifiedResult.replace(hect, acreTerm);
        }
        modifiedResult = this.replaceWordWithCase(modifiedResult, hectaresTerms, acreTerm);
        modifiedResult = this.replaceWordWithCase(modifiedResult, hectareTerms, acreTerm);
        // Replace hectare abbreviation "ha"
        modifiedResult = this.replaceWordWithCase(modifiedResult, hectareAbbrev, acreAbbrev);
        modifiedResult = this.replaceWordWithCase(modifiedResult, tree_ha, tree_acre);
      }
      if (this.ownerRole !== 'farmer') {
        const farmWord = this.translateService.instant('label.farm');
        const shopWord = this.translateService.instant('label.shop');

        // Use the helper function for case-sensitive replacement
        modifiedResult = this.replaceWordWithCase(modifiedResult, farmWord, shopWord);
      }
    }
    return modifiedResult;
  }
}
